import React from 'react';
import NavLateral from './elements/NavLateral';
import ContenidoMain from './components/ContenidoMain';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Inicio from './components/Inicio';
import PortafolioPage from './components/PortafolioPage';
import About from './components/About';
import Contacto from './components/Contacto';
import Aviso from './components/Aviso';

function App() {
  return (
    <>
      <BrowserRouter>
        <NavLateral style={{zIndex: 100}}/>
        <ContenidoMain>
            <Routes>
              <Route path='/' element={ <Inicio/>}/>
              <Route path='/portfolio' element={ <PortafolioPage/> }/>
              <Route path="/about" element={ <About/> }/>
              <Route path="/contact" element={ <Contacto/> }/>
              <Route path="/aviso" element={ <Aviso/> }/>
            </Routes>
        </ContenidoMain>
      </BrowserRouter>
    </>
  );
}

export default App;
